import React, {PropTypes}  from 'react';

class LocationCustomize extends React.Component {

  handleCountryChange(event) {
    //Select the largest city by default
    let country_code_2 = event.target.value;
    let from_city_id = this.props.countries[country_code_2]['largest_city_id']
    let from_city_name = this.props.countries[country_code_2]['largest_city_name']

    // Update user location
    this.props.userLocationActions.customizeLocation(country_code_2, from_city_id, from_city_name);

    // Update prices
    this.props.pricesActions.fetchPrices(from_city_id);
  }

  handleCityChange(event) {
    let country_code_2 = this.props.userLocation.country_code_2
    let from_city_id = event.target.value;
    let from_city_name = this.props.countries[country_code_2]['cities'][from_city_id];

    // Update user location
    this.props.userLocationActions.customizeLocation(country_code_2, from_city_id, from_city_name);

    // Update prices
    this.props.pricesActions.fetchPrices(from_city_id);
  }

  render() {
    // Rebuild the list of countries
    let countries = this.props.countries;
    let country_code_2 = this.props.userLocation.country_code_2;
    let countries_options = [];
    let cities_options = [];

    // Prevent crashes
    if(!countries){
      return (false);
    }

    for(var key in countries) {
      // If this country has cities
      if(countries[key]['largest_city_id'] != 'none') {
        countries_options.push(
          <option value={key} key={key}>{countries[key]['name']}</option>
        )
      }
    }

    // Prevent crashes when country_code_2 is still undefined
    if(country_code_2){

      // Rebuild the list of cities
      let cities_for_selected_country = countries[country_code_2].cities;

      for(var key2 in cities_for_selected_country) {
        cities_options.push(
          <option value={key2} key={key2}>{cities_for_selected_country[key2]}</option>
        )
      }
    }

    return (
      <div>
        <div className="modal" id="location" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 className="modal-title" id="myModalLabel">Home city</h4>
              </div>
              <form>
                <div className="modal-body">
                  <div className="container-fluid">
                    <p>
                      We have estimates for 195 of the world's busiest cities.
                    </p>
                    <p>Display prices for flights starting from:</p>
                    <div className="fields-container">
                      <p><strong>Country</strong></p>
                      <p>
                        <select className="form-control" value={this.props.userLocation.country_code_2 || ''} onChange={this.handleCountryChange.bind(this)}>
                          { countries_options }
                        </select>
                      </p>
                      <p><strong>City</strong></p>
                      <p>
                        <select className="form-control" value={this.props.userLocation.from_city_id || ''} onChange={this.handleCityChange.bind(this)}>
                          { cities_options }
                        </select>
                      </p>
                    </div>
                    <p>
                      <a href="https://www.skyscanner.com" target="_blank">
                        <img src={require('../images/skyscanner.png')} alt="" className="img-responsive skyscanner" />
                      </a>
                    </p>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LocationCustomize.propTypes = {
  pricesActions: PropTypes.object.isRequired,
  userLocation: PropTypes.object.isRequired,
  userLocationActions: PropTypes.object.isRequired,
  countries: PropTypes.object.isRequired
};

export default LocationCustomize;



/** WEBPACK FOOTER **
 ** ./src/components/LocationCustomize.js
 **/